import { __awaiter, __generator } from "tslib";
import { deprecatedInputKey } from './input';
export var createDeprecatedInputDriver = function (wrapper) {
    var input = wrapper.$("." + deprecatedInputKey);
    var inputField = input.$('.input-field');
    return {
        value: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, inputField.value()];
            });
        }); },
        set: function (value) { return inputField.enterValue(value); },
        enterValue: function (value) {
            return inputField.enterValue(value);
        },
        pressEnter: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('not implemented');
            });
        }); },
        disabled: function () { return __awaiter(void 0, void 0, void 0, function () {
            var dis;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, inputField.attr('disabled')];
                    case 1:
                        dis = _a.sent();
                        return [2 /*return*/, !!dis];
                }
            });
        }); },
        readOnly: function () { return __awaiter(void 0, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, inputField.attr('readonly')];
                    case 1:
                        val = _a.sent();
                        return [2 /*return*/, !!val];
                }
            });
        }); },
        valid: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, inputField.hasClass('.invalid')];
            });
        }); },
        errorMsg: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, input.$('.validation-error').text()];
            });
        }); },
        placeholder: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, inputField.attr('placeholder')];
                    case 1: return [2 /*return*/, (_a.sent()) || ''];
                }
            });
        }); }
    };
};
//# sourceMappingURL=driver.js.map